module.exports = __webpack_public_path__ + "static/img/intro-icon6@3x.260a918f.png";